import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
declare var $: any;
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {
  isCollapse: any;
  language: any;
  sidebar: boolean = false;
  screenWidth: any = '';
  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'fr', 'it', 'ja']);
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.screenWidth = window.screen.width;
    this.language = localStorage.getItem('selectedLang');
    if ((!this.language || this.language == 'en') || (this.screenWidth >= 992 && this.screenWidth <= 1024)) {
      this.sidebar = true;
    } else {
      this.sidebar = false;
    }
  }

}